import { render, staticRenderFns } from "./BookingServicesItem.vue?vue&type=template&id=0afd02aa&scoped=true"
import script from "./BookingServicesItem.vue?vue&type=script&lang=ts"
export * from "./BookingServicesItem.vue?vue&type=script&lang=ts"
import style0 from "./BookingServicesItem.vue?vue&type=style&index=0&id=0afd02aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd02aa",
  null
  
)

export default component.exports